const BlockUserLine = ({ className = '', ...props }) => {
    return (
        <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M6.16992 11.3965C3.40842 11.3965 1.16992 9.15798 1.16992 6.39648C1.16992 3.63498 3.40842 1.39648 6.16992 1.39648C8.93142 1.39648 11.1699 3.63498 11.1699 6.39648C11.1699 9.15798 8.93142 11.3965 6.16992 11.3965ZM6.16992 10.3965C7.23079 10.3965 8.2482 9.97506 8.99835 9.22491C9.7485 8.47477 10.1699 7.45735 10.1699 6.39648C10.1699 5.33562 9.7485 4.3182 8.99835 3.56806C8.2482 2.81791 7.23079 2.39648 6.16992 2.39648C5.10906 2.39648 4.09164 2.81791 3.34149 3.56806C2.59135 4.3182 2.16992 5.33562 2.16992 6.39648C2.16992 7.45735 2.59135 8.47477 3.34149 9.22491C4.09164 9.97506 5.10906 10.3965 6.16992 10.3965ZM5.66992 7.89648H6.66992V8.89648H5.66992V7.89648ZM5.66992 3.89648H6.66992V6.89648H5.66992V3.89648Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default BlockUserLine;
